import React from 'react';
import {Flex} from '@chakra-ui/react';
import {IntentModelHeader} from './IntentModelHeader';
import {IntentModelContent} from './IntentModelContent';

export const IntentModel = () => {
  return (
    <Flex direction="column" h="100%">
      <IntentModelHeader />
      <IntentModelContent />
    </Flex>
  );
};
